import { t } from 'ttag';

import {
  Select,
  SelectOption,
  SelectProps,
} from '@ui/Select';

import { useRegionSelectQuery } from './queries/graphql.v4.generated';

export type RegionSelectOption = SelectOption<string>;

type Props = Omit<SelectProps<RegionSelectOption>, 'options'>;

export const RegionSelect: React.FC<Props> = (props) => {
  const { data, loading } = useRegionSelectQuery({
    context: { v4: true },
  });

  let options: readonly RegionSelectOption[] = [];
  if (data && data.orderRegions) {
    options = data.orderRegions.map(
      (region) => ({ label: region.name, value: region.id }),
    );
  }

  return (
    (
      <Select
        {...props}
        isSearchable={false}
        placeholder={t`Виберіть область`}
        isLoading={loading}
        options={options}
      />
    )
  );
};

export default RegionSelect;
